import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
`;

export const TabHeader = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 0;
  align-items: flex-end;
  height: 60px;
`;

export const Tab = styled.div`
  padding: 0px;
  background-color: white;
  display: none;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  ${(props) =>
    props.active &&
    `
    display: flex;
  `}
`;

export const TabLink = styled.div`
  cursor: pointer;
  padding: 10px;
  flex: 1 1 50%;
  background-color: #d5e4ed;
  color: #838384;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 30px;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
  &.active {
    background-color: #ffffff;
    color: #1381c5;
    height: 40px;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    font-weight: 600;
    font-size: 16px;
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

export const Section = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  flex: 1 1 100%;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
  padding: 0;
  margin-bottom: 1em;
  margin: 1em;
  border-radius: 10px;
  background: #f3f8fb;
  padding-bottom: 10px;
`;
export const PlainSection = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  flex: 1 1 100%;
  padding: 1em;
  margin-bottom: 1em;
`;

export const MenuGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(auto, auto, auto);
  gap: 10px;
  height: fit-content;
  width: 100%;
  margin-top:20px;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(auto, auto);
    width: 100%;
    margin-top:20px;
  }
  @media (max-width: 768px) {
    grid-template-columns: auto;
    grid-auto-rows: minmax(auto);
    width: auto;
    padding: 20px 10px;
  }
`;

export const MenuGroupItem = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #d6e0ff;
  border-radius: 10px;
  flex-grow: 1;
  min-width: 150px; /* Adjust min-width as needed */
  padding: 10px;
  margin: 5px;
  position: relative;
  background-color: white;
  // box-shadow: 1px 0px 1px 1px #839d9424;
  background-color: rgb(255, 255, 255);
`;

export const Heading = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
  // position: absolute;
  background: white;
  // top: -17px;
  padding: 5px 20px;
`;
export const MenuBox = styled.div`
  margin: 9px;
`;
export const MenuItem = styled.div`
  margin-bottom: 3px;
  padding: 10px;
  background: #b8d2fa;
  border-radius: 10px;
  box-shadow: 1px 0px 1px 1px #839d9424;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  svg {
    margin-right: 10px;
  }
  &:hover {
    background: #e6ecf4;
    cursor: pointer;
  }
`;

